<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="list-patient">

      <div class="sticky-table-header">
        <vx-card style="overflow-x: auto;">
          <vs-row>
              <vs-col class="search-bar" vs-type="flex" vs-justify="right" vs-align="center">
                  <vs-input ref="searchTxt" icon-no-border icon="icon-search" icon-pack="feather" class="w-full input-rounded-full" placeholder="Cari Pasien" v-model="searchText"  v-on:keyup.enter="search"  v-on:keyup.tab="searchTabClick"/>
                  <vs-tooltip text="Tambah">
                    <vs-button radius size="large" type="border" color="#5d9fc6" icon="person_add" class="ml-3" @click="create()"></vs-button>
                  </vs-tooltip>
                  <vs-tooltip text="Edit" v-if="btnEdit === true">
                    <vs-button radius size="large" type="border" color="warning" icon="edit" class="ml-3" @click="edit()"></vs-button>
                  </vs-tooltip>
                  <vs-tooltip text="Hapus" v-if="btnDel === true">
                    <vs-button radius size="large" type="border" color="danger" icon="delete" class="ml-3"></vs-button>
                  </vs-tooltip>
              </vs-col>
          </vs-row>
        </vx-card>
      </div>

      <vx-card title="Daftar Pasien" class="sticky-table-content1 mt-sticky">
        <vs-table stripe max-items="20"
          :class="showFixedHeader?'sticky-header':''"
          :data="listData"
          @selected="handleSelected">
            <template slot="thead">
                <vs-th sort-key="patientNumber" class="vs-lg-2">No MR</vs-th>
                <vs-th sort-key="name" class="vs-lg-4">Nama Pasien</vs-th>
                <vs-th class="vs-lg-2">Tanggal Lahir</vs-th>
                <vs-th class="vs-lg-2">Jenis Kelamin</vs-th>
                <vs-th class="vs-lg-2">Lokasi</vs-th>
            </template>
            <template slot-scope="{data}">
              <tbody :key="indextr" v-for="(tr, indextr) in data">
                <vs-tr :data="tr" :style="tr.id==idSelected?'background: rgba(var(--vs-primary),.1)!important;':(indextr%2==0?'background: transparent!important;':'')">
                    <vs-td class="vs-lg-2 text-center">
                        {{data[indextr].patientNumber}}
                    </vs-td>
                    <vs-td class="vs-lg-4">
                        {{data[indextr].name}}
                    </vs-td>
                    <vs-td class="vs-lg-2 text-center">
                        {{data[indextr].dob | formatDate}}
                    </vs-td>
                    <vs-td class="vs-lg-2 text-center">
                        {{data[indextr].gender.name}}
                    </vs-td>
                    <vs-td class="vs-lg-2 text-center">
                        {{data[indextr].address}}
                    </vs-td>
                </vs-tr>
              </tbody>
            </template>
        </vs-table>
        <vs-pagination class="pagination pagination-warning" :total="totalItem" v-model="page" @input="find"></vs-pagination>
      </vx-card>
    </div>
</template>

<script>
import ref from "@/api/ref.js";
import formsearch from "@/api/form-search.js";
import patient from "@/api/patient.js";
import tool from "@/tool/form_tool.js";

export default {
  data() {
    return {
			idSelected: null,
			listData: [],
			loading: true,
			perPage: 50,
			page: 1,
      totalItem: 1,

      btnEdit: false,
      btnDel: false,

			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
			},
      searchText: '',
      isUserScrolling: false,
      showFixedHeader: false,
      isMobile: false
    };
  },
  components: {
  },
  methods: {
		listen(newVal, schema) {
		},
		async find(pg) {
			this.model["perPage"] = this.perPage;
			this.model["page"] = pg;
			const frm = await patient.listPatient(this.model);
			if (frm.data.status != false) {
				this.listData = frm.data.data;
				this.totalItem = frm.data.maxPage;
			} else {
			   this.listData = [];
      }
		},
    handleSelected(tr) {
      this.idSelected = tr.id;
      this.btnEdit = true;
      this.btnDel = true;
    },
    create() {
      this.$router.push('/pasien/create');
    },
    edit() {
      this.$router.push({name: 'patient-create', params: {id: this.idSelected}});
    },
		async search() {
      this.page = 1;
			this.model["perPage"] = this.perPage;
      this.model["page"] = 1;
      this.model["keyword"] = this.searchText
			const frm = await patient.listPatient(this.model);
			if (frm.data.status) {
				this.listData = frm.data.data;
				this.totalItem = frm.data.maxPage;
			} else {
			   this.listData = [];
      }
		},
    handleScroll(ev) {
      if(!this.isMobile) {
          this.isUserScrolling = (window.scrollY > 0);
          if (this.isUserScrolling) {
              if (window.pageYOffset > 45) {
                  this.showFixedHeader = true;
              } else {
                  this.showFixedHeader = false;
              }
          } else {
              this.showFixedHeader = false;
          }
      }
    },
    setFocusOnInput(inputName) {
       /**
        * @see https://vuejs.org/v2/api/#vm-el
        * @see https://vuejs.org/v2/api/#vm-refs
        */
        // you could just call this.$refs[inputName].focusInput() but i'm not shure if it belongs to the public API
        let inputEl = this.$refs[inputName].$el.querySelector('input');
        console.log(inputEl.focus);
        inputEl.focus();
    },
    isMobileDevice() {
        const toMatch = [
            /Android/i,
            /webOS/i,
            /iPhone/i,
            /iPad/i,
            /iPod/i,
            /BlackBerry/i,
            /Windows Phone/i
        ];

        console.log(navigator.userAgent);

        return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
    }
  },
  computed: {
  },
  mounted() {
    this.isMobile = this.isMobileDevice();
  },
  created() {
      document.addEventListener('scroll', this.handleScroll);
      this.$nextTick(() => this.setFocusOnInput('searchTxt'))
  },
  destroyed() {
      document.removeEventListener('scroll', this.handleScroll);
  }
};
</script>
